import { reflectKeys } from '@/app/shared/services';
import { namespacedPrefix } from '../config';

const actionsTypes = reflectKeys(['FETCH_DISHES_DATA'], namespacedPrefix);

const { FETCH_DISHES_DATA } = actionsTypes;

export { FETCH_DISHES_DATA };
